import { Controller } from "@hotwired/stimulus";
import DateRangePicker from "daterangepicker";

export default class extends Controller {
  connect() {
    new DateRangePicker(this.element, {
      locale: {
        format: "MM/DD/YY"
      },
      showDropdowns: true,
      maxDate: moment(),
      autoUpdateInput: false,
    }, (start, end, label) => {
      this.element.value = start.format("MM/DD/YY") + " - " + end.format("MM/DD/YY");
    });
  }
}

